import React, { useMemo } from 'react';
import './index.scss';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import TrendTable from './Table';
import { useIntl, getLocale } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';

export default function StreamingTrendsCard(props: any) {
  const {
    lineData = [],
    tableData = [],
    earliestLoading,
    tableHeaderOptions,
    trendComputeType,
    trendCount,
    earlistDate,
    cardStatus,
    entityType,
    gameName,
    gameCover,
    segementTitle,
    chartsTitle,
    chartCardTitle,
    segVal,
    baseReleaseTime = '',
    earliestPeriod = '',
    pageType = '',
    earliestDay = '',
    rightTitle = '',
    dateType,
    startDate,
    endDate,
    ifLineChartLegendOn = false,
    pageSortAttr,
    onTableSortChage,
    trendFetchParams,
    firstWeekSinceReleaseDates,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { isLoading, isError, isNoData } = cardStatus || {};

  const sortListLineCur = useMemo(() => {
    const sortList = ['facebook', 'ytg', 'twitch'];
    const filterPaltform = trendFetchParams?.platform || ['facebook', 'ytg', 'twitch'];
    const sortListCur = sortList.filter((item) => filterPaltform?.includes(item));
    return sortListCur;
  }, [trendFetchParams]);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context dbi-streaming-trends-card-title-height"
        title={`${rightTitle}${locale === 'zh-CN' ? '' : ' '}${formatMessage({
          id: `dbi_detail_trend`,
        })}`}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-streaming-trends-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context dbi-mobileGames-title-custom"
        title={`${rightTitle}${locale === 'zh-CN' ? '' : ' '}${formatMessage({
          id: `dbi_detail_trend`,
        })}`}
        subTitle={`${trendComputeType} ${segementTitle} : ${trendCount}`}
        rightText={
          entityType !== 'mobile' || earliestLoading
            ? ''
            : `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earlistDate}`
        }
        rightTip={
          entityType !== 'mobile' ? undefined : formatMessage({ id: `dbi_detail_earlistdate_info` })
        }
        activeTab={'line'}
        disableChartType={['bar', 'pie']}
      >
        <div className="trends-card-line">
          <Visualis
            lineData={lineData}
            imageType={'mobile'}
            chartsTitle={chartsTitle}
            chartCardTitle={chartCardTitle}
            segVal={segVal}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            pageType={pageType}
            earliestDay={earliestDay}
            tableHeaderOptions={tableHeaderOptions}
            rightTitle={rightTitle}
            segementTitle={rightTitle}
            dateType={dateType}
            ifLineChartLegendOn={ifLineChartLegendOn}
            sortList={sortListLineCur}
            firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
          />
        </div>

        <TrendTable
          tableData={tableData}
          tableHeaderOptions={tableHeaderOptions}
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          dateType={dateType}
          startDate={startDate}
          endDate={endDate}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
        />
      </CardSlotV2>
    </div>
  );
}
